import React, { useEffect, useState } from 'react';
export function StickyMobileCta() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="md:hidden fixed bottom-0 left-0 right-0 p-4 bg-white border-t border-slate-200 shadow-[0_-10px_20px_rgba(0,0,0,0.05)] z-50 animate-in slide-in-from-bottom-full duration-300" data-id="element-246">
      <button onClick={() => {
      window.location.href = 'https://solucionesya.shop/cart/48784011591928:1';
    }} className="w-full bg-terracotta hover:bg-terracotta-hover active:scale-[0.98] text-white font-bold py-3.5 px-4 rounded-xl shadow-md flex items-center justify-between transition-all" data-id="element-247">
        <div className="flex flex-col items-start" data-id="element-248">
          <span className="text-[10px] uppercase tracking-wider opacity-90" data-id="element-249">
            Edición Completa
          </span>
          <span className="text-lg leading-none" data-id="element-250">$27.990</span>
        </div>
        <span className="flex items-center gap-1" data-id="element-251">
          Comprar <span className="text-xl leading-none" data-id="element-252">→</span>
        </span>
      </button>
    </div>;
}